/* eslint-disable react/jsx-key */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { inspireYellow } from "@inspire/ui/static";
var favicons = [
    /*#__PURE__*/ _jsx("meta", {
        name: "theme-color",
        content: inspireYellow
    }, "theme"),
    /*#__PURE__*/ _jsx("link", {
        rel: "manifest",
        href: "/favicons/manifest.json"
    }, "manifest"),
    /*#__PURE__*/ _jsx("link", {
        rel: "shortcut icon",
        href: "/favicon.ico"
    }, "ico"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "192x192",
        href: "/favicons/apple-icon-precomposed.png"
    }, "apple-precomposed-192"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "/favicons/apple-icon-57x57.png"
    }, "apple-57"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "/favicons/apple-icon-114x114.png"
    }, "apple-114"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "/favicons/apple-icon-72x72.png"
    }, "apple-72"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "/favicons/apple-icon-144x144.png"
    }, "apple-144"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "60x60",
        href: "/favicons/apple-icon-60x60.png"
    }, "apple-60"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "/favicons/apple-icon-120x120.png"
    }, "apple-120"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: "/favicons/apple-icon-76x76.png"
    }, "apple-76"),
    /*#__PURE__*/ _jsx("link", {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "/favicons/apple-icon-152x152.png"
    }, "apple-152"),
    /*#__PURE__*/ _jsx("link", {
        rel: "icon",
        type: "image/png",
        href: "/favicons/favicon-96x96.png",
        sizes: "96x96"
    }, "apple-96"),
    /*#__PURE__*/ _jsx("link", {
        rel: "icon",
        type: "image/png",
        href: "/favicons/favicon-16x16.png",
        sizes: "16x16"
    }, "fav-16"),
    /*#__PURE__*/ _jsx("link", {
        rel: "icon",
        type: "image/png",
        href: "/favicons/favicon-32x32.png",
        sizes: "32x32"
    }, "fav-32"),
    /*#__PURE__*/ _jsx("meta", {
        name: "msapplication-TileColor",
        content: "#27374a"
    }, "ms-theme"),
    /*#__PURE__*/ _jsx("meta", {
        name: "msapplication-TileImage",
        content: "/favicons/mstile-144x144.png"
    }, "ms-image"),
    /*#__PURE__*/ _jsx("meta", {
        name: "msapplication-config",
        content: "/favicons/browserconfig.xml"
    }, "ms-config"), 
];
export default favicons;
